import { render, staticRenderFns } from "./ModalPageItemError.vue?vue&type=template&id=255ab3c2&scoped=true"
import script from "./ModalPageItemError.vue?vue&type=script&lang=js"
export * from "./ModalPageItemError.vue?vue&type=script&lang=js"
import style0 from "./ModalPageItemError.vue?vue&type=style&index=0&id=255ab3c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255ab3c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('255ab3c2')) {
      api.createRecord('255ab3c2', component.options)
    } else {
      api.reload('255ab3c2', component.options)
    }
    module.hot.accept("./ModalPageItemError.vue?vue&type=template&id=255ab3c2&scoped=true", function () {
      api.rerender('255ab3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalPageItemError.vue"
export default component.exports